import { AppType } from '~/graphql/types';

/**
 *
 * @param {AppType} appType - AppType
 * keywords: isnvmapp, requiresnvmauth
 */
const isNvmApp = (appType: AppType): boolean =>
  appType === AppType.BbWaardecheck || appType === AppType.Biedwijzer;

export default isNvmApp;
